import { t, getal } from '../i18n.js';

/**
 * Liggende balken, één reeks: de naam, de balk en het getal ernaast (de tekst in inkt, de balk in cyaan). `voor`: een vlag.
 * Met `onKies` is elke rij aan te klikken (Firewall › IPS: de meldingen van die regel); `gekozen` is de naam die open staat.
 */
export default function Balken({ rijen, onKies = null, gekozen = null }) {
  if (!rijen.length) return <p className="empty">{t('Niets.')}</p>;
  const max = Math.max(...rijen.map((r) => r.n));
  return (
    <div className="balken">
      {rijen.map((r) => (
        <div key={r.naam} className={`balk${onKies ? ' klik' : ''}`} title={`${r.naam}: ${getal(r.n)}`}
          {...(onKies ? { role: 'button', tabIndex: 0, 'aria-pressed': gekozen === r.naam, onClick: () => onKies(r.naam),
            onKeyDown: (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onKies(r.naam); } } } : {})}>
          <span className="naam">{r.voor}{r.naam}{r.extra && <span className="muted"> · {r.extra}</span>}</span>
          <span className="spoor"><span style={{ width: `${Math.max(2, (r.n / max) * 100)}%` }} /></span>
          <span className="num">{getal(r.n)}</span>
        </div>
      ))}
    </div>
  );
}
